import actionTypes from "./actionTypes";
import api from "./api";
export default {
    saveWorkSpace: (workSpace) => ({
        type: actionTypes.SAVE_WORK_SPACE,
        payload: {
            promise: () => api.saveWorkSpace(workSpace)
        },
        scope: `${actionTypes.SAVE_WORK_SPACE}_${workSpace.Id}`
    }),
    setDraft: (draft) => ({
        type: actionTypes.SET_DRAFT,
        draft
    }),
    getWorkSpace: (workSpaceId) => ({
        type: actionTypes.GET_WORK_SPACE,
        payload: {
            promise: () => api.getWorkSpace(workSpaceId)
        },
        scope: `${actionTypes.GET_WORK_SPACE}_${workSpaceId}`
    }),
    setWorkSpaceId: (workSpaceId) => ({
        type: actionTypes.SET_WORK_SPACE_ID,
        workSpaceId
    }),
    setNewWorkSpace: () => ({
        type: actionTypes.SET_NEW_WORK_SPACE
    })
};
